// ABOUTME: The orientation's Schedule a Session button, without any scheduling behaviour
// ABOUTME: FreeBusy binds it by id; the Nylas picker opens from its onClick
import { observer } from 'mobx-react';
import * as React from 'react';
import * as style from '../../style.module.css';
import { T } from '../../../../../Translations';
import ArrowRightIcon from '../../../../Cutesies/ArrowRightIcon';

interface Props {
  buttonId: string;
  disabled: boolean;
  onClick: () => void;
}

const ScheduleButtonView: React.FC<Props> = ({ buttonId, disabled, onClick }) => (
  <button
    className={style.continueButton}
    data-test-coaching-orientation-button={'Schedule a Session'}
    data-intercom-target="coaching-orientation-schedule-button"
    id={buttonId}
    disabled={disabled}
    onClick={onClick}
  >
    <T kind={'Schedule a Session'} />
    <div className={style.buttonIcon}>
      <ArrowRightIcon />
    </div>
  </button>
);

export default observer(ScheduleButtonView);
